<template>
  <div style="height:100%">
    <SplitContainer4 style="height:100%" :layout="12" :split_setting1="0.76" :split_setting2="0.55" :split_height="156">
      <template #top>
        <TableMain ref="QTHDistributionEditProTable1" :fields="fields1" :title="table_title.title1"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_query_container="false"
          :show_toolbar_container="true" :show_pagination_container="true" :show_date_picker="false"
          :show_toolbar="true" :show_filter="true" :isBusy="isBusy" :table_height_adjust="8"
          :show_toolbar_button="[0, 0, 0, 0, 0]" :show_close="true" :show_confirm="true"
          :hb_table_class="'hb_table_qthdistribution_edit_pro_class1'" @current_changed="current_changed"
          @state_change="state_change" @on_cell_button_click="on_cell_button_click1" tableref="9300dae15e68426bbe0b90a5cdf57b0f">
          <template #toolbar>
            <div style="display: inline-block">
              <el-button type="danger" plain @click="ConsultQuoteAgain" class="ml-2 iconfont icon-edit"
                size="mini">重新询价</el-button>
              <el-date-picker class="ml-1" size="small" style="width: 220px" v-model="date_range" type="daterange"
                align="right" unlink-panels range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions()">
              </el-date-picker>
              <el-select placeholder="请输入报价申请编号关键词" size="small" v-model="QuotationTaskNum" filterable remote
                reserve-keyword :loading="loading" :remote-method="QTRemoteMethod" clearable @clear="QTRemoteMethod('')"
                class="w-10 ml-1" @change="on_query(false)">
                <el-option v-for="(t, k) in QTOptions" :key="k" :label="t.label" :value="t.value"></el-option>
              </el-select>
              <QueryButton class="ml-1" @on_query="on_query_t" :label="$t(query_lable)"></QueryButton>
              <el-popover placement="right" title="提示" width="300" trigger="hover" style="border-color: red;">
                <p>1、默认显示未确认且有报价的数据;</p>
                <p>2、重新询价会自动创建询价申请及询价单;</p>
                <i slot="reference" class="el-icon-question ml-1" style="font-size:18px;margin-top: 6px;"></i>
              </el-popover>
              <el-checkbox-group style="display: inline-block" class="ml-1" v-model="checkedConditions"
                @change="only_methods">
                <el-checkbox v-for="(item, index) in onlyCheckOptions" :label="item.value" :key="index">{{
                  item.label }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </template>
        </TableMain>
      </template>
      <template #center>
        <TableMain ref="QTHDistributionEditProTable2" :fields="qth_distribution_price_fields"
          :show_query_container="false" :title="table_title.title2" :show_toolbar="false"
          :show_toolbar_container="false" :show_toolbar_state="false" :date_picker_label="''" :table_height_adjust="8"
          :show_pagination="true" :show_filter="false" :pager_count="5" :isBusy="isBusy2"
          :show_toolbar_button="[0, 0, 0, 0, 0]" @on_cell_button_click="on_cell_button_click"
          :hb_table_class="'hb_table_qthdistribution_edit_pro_class2'" tableref="f4d3ad00794b43adbb7ea1253001b1e6">
          <template #operation>
            <el-button type="info" plain style="width: 55px" class="ml-2" @click="getDetailIntoDistribution"><i
                class="fa fa-plus"></i></el-button>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain ref="QTHDistributionEditProTable3" :fields="distribution_fields" :show_query_container="false"
          :title="table_title.title3" :date_picker_label="date_picker_label" :table_height_adjust="2"
          :show_pagination="true" :show_toolbar_state="false" :show_filter="false" :pager_count="5" :isBusy="isBusy3"
          @state_change="detail_state_change" :show_toolbar_button="[0, 0, 0, 0, 1]"
          :hb_table_class="'hb_table_qthdistribution_edit_pro_class3'" @on_input="distribution_on_input" tableref="df6023a5a4a64d97baa9cb629941dfea">
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
              @on_query="Distribution_SaveData" :label="$t('common.save')" class="ml-2"></QueryButton>
          </template>
        </TableMain>
      </template>
    </SplitContainer4>

    <!-- 附件 -->
    <el-dialog :title="dialog_title" :visible.sync="accessoryVendVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refVendAccessory" :accessoryCategory="'ConsultQuoteVend'" :showUpload="false"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
import * as commonController from "../../controllers/commonController"
import * as CostItemsController from "../../controllers/sd/CostItemsController"
import * as QuotationTaskController from "../../controllers/sd/QuotationTaskController"
import * as QuotationTaskHandleController from "../../controllers/sd/QuotationTaskHandleController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as VendInitialQuoteController from "../../controllers/sd/VendInitialQuoteController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import FileUpload from "../FileUpload.vue"
import QueryButton from "../components/base/QueryButton"
import SplitContainer4 from "../components/container/SplitContainer4"
import TableMain from "../components/table/TableMain"

export default {
  components: {
    SplitContainer4,
    TableMain,
    QueryButton,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      date_range: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "main_plan_edit_proofing",
        title2: "quote_supplier",
        title3: "quote_apply_distribut",
      },
      fields1: _.cloneDeep(CostItemsController.fields.qt_all_ok_detail_pro),
      qth_distribution_price_fields: _.cloneDeep(CostItemsController.fields.qth_distribution_price_fields),
      distribution_fields: _.cloneDeep(QuotationTaskHandleController.fields.detail_distribution),
      QuotationTaskNum: "",//报价申请编号
      isBusy: false,
      isBusy2: false,
      isBusy3: false,
      total_cost: 0,
      cur_product_qty: 1,
      QTOptions: [],
      all_role_users: [],
      SelectedVends: [],
      VendersOptions: [],
      VendersOptionsHis: [],
      hisData: [],
      checkedConditions: [],
      onlyCheckOptions: [
        { value: 1, label: "显示全部" }
      ],
      loading: false,
      current_accessory_code: 'VendAccessory',
      current_vend_accessory: null,///当前供应商选中附件
      accessoryVendVisible: false,
      dialog_title: '附件列表'
    }
  },
  async created() {
    const end = new Date()
    const start = this.$date.addMonths(new Date(), -3)
    this.date_range = [start, end]
    this.qth_distribution_price_fields = _.filter(this.qth_distribution_price_fields, (t) => { return t.key != 'DistributionRatio' })
    await this.getAllRoleUsers()
  },
  mounted() { },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    ///获取报价申请编号
    async getKvQuoteTask(query) {
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskNum = { like: "%" + query + "%" }
      let _result = await QuotationTaskController.methods.getData(p, "transport")
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_.filter(_result[0], { fcCheckSQOApproved: true }), (t) => {
          return { value: t.QuotationTaskNum, label: t.dataAreaId + ":" + t.QuotationTaskNum }
        })
        this.QTOptions = _.orderBy(dt.slice(0, 300), ["value"], ["desc"])
      }
      this.loading = false
    },
    ///报价申请编号下拉
    async QTRemoteMethod(query) {
      this.QTOptions = []
      this.loading = true
      await this.getKvQuoteTask(query)
    },
    async on_query_t(cb) {
      await this.on_query(false)
      cb()
    },
    async on_query(isLoading = true) {
      this.QuotationTaskNum = _.trim(this.QuotationTaskNum)
      if (isLoading) {
        this.isBusy = true
      }
      this.$refs.QTHDistributionEditProTable2.SetData([])
      this.$refs.QTHDistributionEditProTable3.SetData([])
      let p = { QuotationType: "打样报价", QuotationTaskNum: this.QuotationTaskNum }
      if (!_.isNull(this.date_range)) {
        let _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        p.date_from = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        p.date_to = _toDate
      }
      let _result = await QuotationTaskController.methods.getDetailAllOkData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _result[0]
        _.each(dt, (t) => {
          t._error = !t.is_proofing_confirm
          if (t.closed == 0) {
            if ((!t.IsDistributedOk && !t.IsAllApprovedOk) || t.is_weightcost_refused) t._error = true
          }
          t.AccessoryCount = 0
          if (t.Accessory && t.Accessory != "")
            t.AccessoryCount = JSON.parse(t.Accessory).length
        })
        this.hisData = _.orderBy(dt, ["QuotationTaskNum", "LineNum"], ["desc", "asc"])
        this.only_methods(this.checkedConditions)
      }

      this.isBusy = false
    },
    only_methods(v) {
      let checkedValue = _.last(v)
      this.checkedConditions = [checkedValue]
      let dt = _.cloneDeep(this.hisData)
      if (checkedValue == undefined) {///显示全部
        dt = _.filter(dt, (t) => {
          ///默认显示分配完成但未确认的数据
          if (t.fcCheckSQOHasPriceOrCost === true && t.is_proofing_confirm === false)
            return t
        })
      }

      this.$refs.QTHDistributionEditProTable1.SetData(_.orderBy(dt, ["QuotationTaskNum", "LineNum"], ["desc", "asc"]))
    },
    ///打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: "部件档案",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },

    async current_changed(old, current) {
      if (current) {
        await this.getDetailCost()//获取制造商报价
        await this.Distibution_Query()
      }
    },
    async getDetailCost(isLoading = true) {
      this.VendersOptionsHis = []
      let current = this.$refs.QTHDistributionEditProTable1.GetCurrentItem()
      if (!current) {
        return
      }
      if (isLoading) {
        this.isBusy2 = true
        this.$refs.QTHDistributionEditProTable2.SetData([])
      }
      let p1 = { ItemId: "%" + current.ItemId + "%" }
      let _result1 = await VendInitialQuoteController.methods.getDataSql(p1)
      if (_result1 && _result1[0] && _result1[0].length > 0) {
        let redt = _.filter(_result1[0], (t) => {
          ///只要采购确认了有价格都显示
          let is_distribut_ok = false
          if (t.DistributionRatio && t.DistributionRatio !== '' && _.findIndex(JSON.parse(t.DistributionRatio), o => o.ItemId === current.ItemId) > -1) {
            is_distribut_ok = true
          }
          console.log(current.ItemId, JSON.parse(t.DistributionRatio))
          return t.QuotationTaskNum === current.QuotationTaskNum && is_distribut_ok
        })
        let rdt = _.groupBy(redt, "AccountNum")
        let rt = []
        for (var i in rdt) {
          _.each(rdt[i], (t) => {
            t.DeliveryAddress = current.DeliveryAddress
            t.DeliveryMode = current.DeliveryMode
            let _transport = t.Transport ? t.Transport : 0
            t.AccountName = t.SEI_Name
            t.TransportCost = _transport
            let _qty = t.QuantityAmountTo ? t.QuantityAmountTo : t.QuantityAmountFrom
            t.TotalAllCost = _.round(_qty * t.AmountWOTax + _transport, 6)
            t.PerCost = t.AmountWOTax
            if (t.DistributionRatio && t.DistributionRatio != "") {
              let distributionRatioJson = JSON.parse(t.DistributionRatio)
              let m = _.find(distributionRatioJson, { ItemId: current.ItemId })
              if (m) t.DistributionRatio = m.DistributionRatio
              else t.DistributionRatio = ""
            }
            t.AccessoryVendCount = 0
            if (t.VendAccessory && t.VendAccessory != "")
              t.AccessoryVendCount = JSON.parse(t.VendAccessory).length
            this.VendersOptionsHis.push({ value: t.AccountNum, label: t.AccountName })
            rt.push(t)
          })

        }
        this.VendersOptionsHis = _.uniqWith(this.VendersOptionsHis, _.isEqual)
        this.VendersOptions = this.VendersOptionsHis
        this.$refs.QTHDistributionEditProTable2.AppendItems(rt)
      }
      this.isBusy2 = false
    },

    handleClose(done) {
      this.$confirm('确认关闭？').then(t => { done() }).catch(t => { })
    },
    transToContext(t, type) {
      if (type == 0) {
        t.BomCostData = JSON.stringify(t.BomCostData)
        t.CaclBomCostData = JSON.stringify(t.CaclBomCostData)
        t.CaclRouteData = JSON.stringify(t.CaclRouteData)
        t.CalcRsrcCostData = JSON.stringify(t.CalcRsrcCostData)
        t.CostGroupData = JSON.stringify(t.CostGroupData)
        t.WrkCtrCostData = JSON.stringify(t.WrkCtrCostData)
      }
      else {
        t.BomCostData = JSON.parse(t.BomCostData)
        t.CaclBomCostData = JSON.parse(t.CaclBomCostData)
        t.CaclRouteData = JSON.parse(t.CaclRouteData)
        t.CalcRsrcCostData = JSON.parse(t.CalcRsrcCostData)
        t.CostGroupData = JSON.parse(t.CostGroupData)
        t.WrkCtrCostData = JSON.parse(t.WrkCtrCostData)
      }
    },
    //#endregion

    //#region 报价明细相关
    ///查询报价明细
    async Detail_Query(QTId) {
      this.isBusy2 = true
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskId = { "=": QTId }
      let _result = await QuotationTaskController.methods.getDetailData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.map(_result[0], (t) => {
          t.IsHomemade = t.IsHomemade ? 1 : 0
          return t
        })
        this.$refs.QTHDTable2.SetData(_.orderBy(dt, ["LineNum"], ["asc"]))
      }
      this.isBusy2 = false
    },
    async detail_current_changed(old, current) {
      this.$refs.QTHDistributionEditProTable3.SetData([])
      if (current) {
        await this.Distibution_Query(current.id)
      }
    },
    //#endregion
    //#region 分配明细相关
    ///查询分配明细
    VendersRemoteMethod(query) {
      let dt = this.VendersOptionsHis
      if (query != "") {
        dt = _.filter(dt, (t) => {
          return _.includes(t.value, query) || _.includes(t.label, query)
        })
      }
      dt = _.slice(dt, 0, 100)

      this.VendersOptions = dt
      if (this.SelectedVends.length > 0) {
        for (var i in this.SelectedVends) {
          if (!_.some(this.VendersOptions, { value: this.SelectedVends[i] })) {
            let m = _.find(this.VendersOptionsHis, { value: this.SelectedVends[i] })
            this.VendersOptions.unshift(m)
          }
        }
      }
    },

    async Distibution_Query(isLoading = true) {
      let current = this.$refs.QTHDistributionEditProTable1.GetCurrentItem()
      if (isLoading) {
        this.isBusy3 = true
        this.$refs.QTHDistributionEditProTable3.SetData([])
      }
      let p = { is_deleted: { "=": 0 } }
      p.QuotationTaskDetailId = { "=": current.id }
      let _result = await QuotationTaskHandleController.methods.getDistributionData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let dt = _.orderBy(_result[0], ["LineNum"], ["asc"])
        _.each(dt, (t) => {
          t.FromBatchQty = current.FromBatchQty
          t.BatchQty = current.BatchQty
        })
        this.$refs.QTHDistributionEditProTable3.SetData(dt)
      }
      this.isBusy3 = false
    },
    ///针对选中明细添加到分配列表中
    getDetailIntoDistribution() {
      let current = this.$refs.QTHDistributionEditProTable1.GetCurrentItem()
      let _qty = current.BatchQty
      if (!current.BatchQty) _qty = current.FromBatchQty
      let selected_items = _.filter(this.$refs.QTHDistributionEditProTable2.GetSelectedItems(), (t) => {
        return t.QuantityAmountFrom <= _qty && t.QuantityAmountTo >= _qty
      })

      if (selected_items && selected_items.length == 0) {
        this.msgToasts("请选择供应商制造成本或报价！", "info")
        return
      }
      let dt3 = this.$refs.QTHDistributionEditProTable3.my_data
      let items_length = dt3.length
      if (items_length > 0) {
        let last_m = _.last(dt3)
        items_length = last_m.LineNum
      }
      let newItems = []
      _.each(selected_items, (current2) => {
        let m = {}
        m.id = ""
        m.LineNum = ++items_length
        m.QuotationTaskDetailId = current.id
        m.FromBatchQty = current.FromBatchQty
        m.BatchQty = current.BatchQty
        m.DistributionRate = _.toNumber(current2.DistributionRatio)
        m.Qty = _.round((current2.DistributionRatio * _qty / 100), 2)
        m.ItemId = current.ItemId
        m.NameAlias = current.NameAlias
        m.Price = current.Price//申请报价
        m.AccountNum = current2.AccountNum
        m.AccountName = current2.AccountName
        m.ConsultQuoteNum = current2.ConsultQuoteNum
        m.PerPrice = current2.AmountWOTax
        m.TotalCost = _.round(m.Qty * current2.AmountWOTax, 6)
        m.OtherCost = current2.TransportCost
        m.DistributionRatePre = current2.DistributionRatio
        m.VendAccessory = current2.VendAccessory
        let index = _.findIndex(dt3, (xt) => {
          return xt.AccountNum == current2.AccountNum && xt.ConsultQuoteNum == current2.ConsultQuoteNum && xt.Qty <= m.Qty
        })
        if (index < 0)
          newItems.push(m)
      })
      this.$refs.QTHDistributionEditProTable3.AppendItems(newItems)
    },
    ///分配状态切换
    async detail_state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      if (data.state === "deleted") {
        let dm = this.$refs.QTHDistributionEditProTable1.GetCurrentItem()
        if (dm.IsAllApprovedOk && !dm.is_weightcost_refused) {
          this.msgToasts("数据已审批，不能执行该操作！", "info")
          cb(null)
          return
        }

        let v = await this.msgModal(this.$t("notify.is_deleted"))

        if (v) {
          let db_del_dt = _.filter(data.selected_items, (t) => { return t.id != "" })
          let del_dt = _.filter(data.selected_items, (t) => { return t.id == "" })
          if (db_del_dt.length > 0) {
            let p = { delete: db_del_dt }
            let rt = await QuotationTaskHandleController.methods.saveDistributionData(p)
            if (rt) {
              this.$refs.QTHDistributionEditProTable3.RemoveItems(db_del_dt)
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(false)
            }
            else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
              cb(false)
            }
          }
          this.$refs.QTHDistributionEditProTable3.RemoveItems(del_dt)
        }
      }
    },
    ///明细行输入事件
    distribution_on_input(data) {
      if (data.field.key == "DistributionRate") {
        let lt = _.each(_.cloneDeep(this.$refs.QTHDistributionEditProTable3.my_data), (t) => {
          if (!t.DistributionRate) {
            t.DistributionRate = 0
          }
          else {
            t.DistributionRate = parseFloat(t.DistributionRate)
          }
        })
        let total_rate = _.sumBy(lt, "DistributionRate")
        if (total_rate > 100) {
          let _rate = 100 - (total_rate - data.item.DistributionRate)
          data.item.DistributionRate = _rate
        }
        data.item.Qty = ""
        data.item.PerPrice = ""
        data.item.TotalCost = ""
        data.item.OtherCost = ""
        data.item.DistributionRatePre = ""
        if (data.item.DistributionRate) {
          data.item.Qty = _.round((data.item.DistributionRate * data.item.BatchQty / 100), 2)
          let dt = _.filter(this.$refs.QTHDistributionEditProTable2.my_data, (t) => {
            return t.QuantityAmountFrom <= data.item.Qty && t.QuantityAmountTo >= data.item.Qty && t.AccountNum === data.item.AccountNum
          })
          dt = _.orderBy(dt, ["update_at"], ["desc"])
          if (dt.length > 0) {
            let m = dt[0]
            data.item.PerPrice = m.AmountWOTax
            data.item.TotalCost = _.round(data.item.Qty * data.item.PerPrice, 6)
            data.item.OtherCost = m.TransportCost
            data.item.DistributionRatePre = _.toNumber(m.DistributionRatio)
          }
        }
      }
    },
    ///保存分配详情
    async Distribution_SaveData(cb) {
      //数据验证
      let msg = "", p = { add: [], edit: [] }
      let detail_data = this.$refs.QTHDistributionEditProTable3.my_data
      if (detail_data.length == 0) {
        cb(null)
        return
      }
      ///检查主单数据状态
      let dm = this.$refs.QTHDistributionEditProTable1.GetCurrentItem()
      if (dm.closed == 2) {
        this.msgToasts("报价已关闭，不能执行该操作！", "info")
        cb(null)
        return
      }
      if (dm.IsAllApprovedOk && !dm.is_weightcost_refused) {
        this.msgToasts("数据已审批，不能执行该操作！", "info")
        cb(null)
        return
      }
      ///检查明细数据
      let repeat_num = []
      let group_dt = _.groupBy(detail_data, "AccountNum")
      for (var i in group_dt) {
        if (group_dt[i].length > 1)
          repeat_num.push(i)
      }
      if (repeat_num.length > 0) {
        this.msgToasts(_.join(repeat_num, ",") + " 供应商编号有多个比例，不能执行该操作！", "info")
        cb(null)
        return
      }

      let index = _.findIndex(detail_data, (t) => { return t.DistributionRate == "" || t.DistributionRate == null || t.DistributionRate == 0 })
      if (index > -1) {
        this.msgToasts("请输入比例！", "info")
        cb(null)
        return
      }
      // let index1 = _.findIndex(detail_data, (t) => { return t.TotalCost == "" || t.TotalCost == null })
      // if (index1 > -1) {
      //   this.msgToasts("总成本不存在，暂不能执行该操作！", "info")
      //   cb(null)
      //   return
      // }

      let is_exceed100 = _.sumBy(detail_data, "DistributionRate")
      if (is_exceed100 > 100 || is_exceed100 < 100) {
        this.msgToasts("分配比例非100%，不能执行该操作！", "info")
        cb(null)
        return
      }
      let require_fileds = _.map(_.filter(this.detail_fields, { required: true }), (t) => { return t })
      _.each(detail_data, (t) => {
        let m = _.cloneDeep(t)
        for (var k in m) {
          if (_.startsWith(k, "_")) delete m[k]
        }
        for (var i in require_fileds) {
          let fm = require_fileds[i]
          if (msg == "" && m[fm.key] == "") {
            msg = fm.label + "不能为空！"
          }
        }
        delete m.create_by_username
        delete m.create_by
        delete m.FromBatchQty
        delete m.BatchQty
        delete m.ConsultQuoteNum
        if (m.id == "") {
          delete m.id
          p.add.push(m)
        }
        else {
          p.edit.push(m)
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(null)
        return
      }

      let rt = await QuotationTaskHandleController.methods.saveDistributionProofingData(p)
      if (rt) {
        await this.Distibution_Query(false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true, true)
      }
      else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    ///重新询价
    async ConsultQuoteAgain() {
      let dt = this.$refs.QTHDistributionEditProTable1.GetSelectedItems()
      if (dt.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        return
      }
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        return
      }
      console.log(dt)
      ///填写重新询价的备注
      let confirm_m = await this.$prompt('请输入重新询价备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\S\s]+$/,
        inputErrorMessage: '请输入重新询价备注',
        inputValue: ""
      }).then(({ value }) => {
        return { state: true, val: value }
      }).catch(() => {
        return { state: false }
      })
      if (confirm_m && confirm_m.state) { }
      else return

      let loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      setTimeout(async () => {
        ///1、按客户分组
        const group_by_customer = _.groupBy(dt, 'CustAccount')
        ///2、分组执行重新询价
        const params = [] ///Array<{ json: [] }>
        for (var k in group_by_customer) {
          params.push({ json: JSON.stringify(group_by_customer[k].map((t) => { return { qt_detail_id: t.id, Description: confirm_m.val } })) })
        }
        let rt = await QuotationTaskHandleController.methods.generateConsultApplayAndOrder(params)
        if (rt) {
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          await this.on_query(false)
        }
        else
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        loading.close()
      }, 1000)

    },
    //#endregion
    //#region 附件
    on_cell_button_click(data) {
      this.current_accessory_code = 'VendAccessory'
      this.current_vend_accessory = data.item
      this.dialog_title = '供应商附件列表'
      this.accessoryVendVisible = true
    },
    on_cell_button_click1(data) {
      this.current_accessory_code = 'Accessory'
      this.current_vend_accessory = data.item
      this.dialog_title = '附件列表'
      this.accessoryVendVisible = true
    },
    bottomDialogOpened() {
      let _accessory = this.current_vend_accessory.VendAccessory
      if (this.current_accessory_code == 'VendAccessory') {
        _accessory = this.current_vend_accessory.VendAccessory
      }
      else if (this.current_accessory_code == 'Accessory') {
        _accessory = this.current_vend_accessory.Accessory
      }
      this.$refs.refVendAccessory.getAccessory(_accessory, this.current_vend_accessory.ItemId)
    },
    bottomSetAccessory(data) {
      if (this.current_accessory_code == 'VendAccessory') {
        this.current_vend_accessory.VendAccessory = data
      }
      else if (this.current_accessory_code == 'Accessory') {
        this.current_vend_accessory.Accessory = data
      }
    },
    //#endregion
    ///关闭报价申请
    async state_change(data, cb) {
      let ask = await this.msgModal(this.$t("notify.is_continue"))
      if (!ask) {
        cb(false)
        return
      }
      ///关闭
      if (data.state == "closed") {
        if (data.selected_items.length == 0) {
          this.msgToasts(this.$t("notify.not_data"), "info")
          return
        }
        if (_.findIndex(data.selected_items, (t) => t.closed == 1 || t.closed == 2) > -1) {
          this.msgToasts("已关闭或发送关闭申请，不能执行改操作！", "info")
          return
        }
        if (_.findIndex(data.selected_items, (t) => t.SalesQuoteWeightCostApproved) > -1) {
          this.msgToasts("加权成本已审批，不能执行该操作！", "info")
          return
        }
        let confirm_m = await this.$prompt('请输入关闭原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^[\S\s]+$/,
          inputErrorMessage: '请输入原因',
          inputValue: ""
        }).then(({ value }) => {
          return { state: true, val: value }
        }).catch(() => {
          return { state: false }
        })
        if (confirm_m && confirm_m.state) { }
        else return

        let dt = _.map(data.selected_items, (t) => {
          return {
            QuotationTaskDetailId: t.id,
            Description: confirm_m.val
          }
        })
        let _result = await QuotationTaskController.methods.addQuoteCloseApplication(dt)
        if (!_.isNull(_result) && _result && _result.length > 0) {
          //关闭时给报价申请发送关闭申请邮件
          let _dt = _.map(_.cloneDeep(data.selected_items), (t) => {
            t.CloseDescription = confirm_m.val
            t.CloseUserName = this.$global.global_data.local_username
            t.CloseDate = this.formatDate(new Date(), "yyyy-MM-dd HH:mm:ss")
            switch (t.IsHomemade) {
              case 0: t.IsHomemade = '否'; break
              case 1: t.IsHomemade = '是'; break
              case 2: t.IsHomemade = '纯外协'; break
            }
            return t
          })
          let email_data = _.groupBy(_dt, "create_by_username")
          await commonController.handleEmailData(email_data, "quote_order_closed", this)
          await this.on_query(false)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
        }
        else
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
      ///确认
      else if (data.state == "confirm") {
        let confirm_action_dt = _.filter(data.selected_items, (t) => !t.is_proofing_confirm)
        let check_params = _.map(confirm_action_dt, (t) => { return { QuotationTaskDetailId: t.id } })
        let check_rt = await QuotationTaskController.methods.checkBeforeConfirmQTHDPro(check_params)
        // console.log(check_rt)
        let error_dt = _.filter(check_rt, (ct) => {
          if (ct[0].quote_proofing_distribution_ok === 0) return ct[0]
        })
        if (error_dt.length > 0) {
          this.msgToasts("存在未分配打样，不能执行改操作！", "info")
          return
        }
        let p = _.map(confirm_action_dt, (t) => {
          return {
            id: t.id,
            is_proofing_confirm: true,
            proofing_confirm_by: this.$store.state.biz_data.userInfo.user_id,
            proofing_confirm_at: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
          }
        })

        let _result = await QuotationTaskController.methods.confrimQTHDPro(p)
        if (!_.isNull(_result) && _result && _result.length > 0) {
          await this.on_query(false)
          await this.SendEmailProofingConfirm(confirm_action_dt)
          this.msgToasts(this.$t("notify.action_successfully"), "success")
        }
        else
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    async SendEmailProofingConfirm(confirm_action_dt) {
      ///发邮件给报价申请创建人和打样报价单审批人
      let _profit_m = _.find(this.$store.state.biz_data.baseData.SystemSetting, { code: "email_notifier" })
      if (_profit_m && _profit_m.setting_value != "") {
        let m = JSON.parse(_profit_m.setting_value)
        if (m.quoteProofingEmailNotifier && m.quoteProofingEmailNotifier.length > 0) {
          let eusers = _.map(confirm_action_dt, (t) => { return t.create_by_username }) ///包括打样报价申请的创建人
          let roles = _.map(this.$store.state.biz_data.userInfo.user_roles_privileges.roles, "code")
          for (var i in m.quoteProofingEmailNotifier) {
            if (_.includes(roles, m.quoteProofingEmailNotifier[i])) {
              let _result = await RoleManageController.methods.GetRoleUsers(-1, m.purchEmailNotifier[i])
              _result = _.filter(_result, { is_sys: false })
              if (_result && _result.length > 0) {
                _.each(_result, (t) => {
                  eusers.push(t)
                })
              }
            }
            else
              eusers.push(m.quoteProofingEmailNotifier[i])
          }

          let _p = _.map(confirm_action_dt, (t) => { return { QuotationTaskDetailId: t.id } })
          await commonController.handleEmailNotify(_p, "quote_proofing_complated", this, this.all_role_users, "get_quotation_order_proofing", _.uniq(eusers))
        }
      }
    }
  }
}
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.bom .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #1138e1b3;
  color: #fff;
}

.hb_table_qthdistribution_edit_pro_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 175rem;
}

.hb_table_qthdistribution_edit_pro_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}

.hb_table_qthdistribution_edit_pro_class3 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 95rem;
}

.bom .el-card__body,
.el-main {
  padding: 0px;
}

.bom .el-drawer__header {
  font-size: 1.1rem;
  color: black;
  padding-left: 0.5rem;
}
</style>
